module.exports = __webpack_public_path__ + "static/media/Decoration_Christmas.3c84e218.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/themedEvent/decorations/Decoration_Christmas.png
// module id = 1344
// module chunks = 3